import type { User } from '../types/auth';

/**
 * Quem é "gente da Snapfy" para efeito de FERRAMENTAS INTERNAS DE DIAGNÓSTICO
 * (ex.: a tag que diz qual modelo de IA gerou uma imagem).
 *
 * Critério: domínio `@snapfy.ai`. Nada além disso.
 *
 * Por que NÃO reusa o `isOrdersStaff`, apesar da semelhança:
 *
 * 1. `isOrdersStaff` exige e-mail VERIFICADO, e com razão — ele libera o módulo
 *    de Pedidos, que expõe CNPJ e anamnese de clientes reais. Aqui o que se
 *    revela é o nome do modelo que rodou; o custo de errar não é comparável.
 *    Medido em produção (17/08/2026): 6 das 17 contas `@snapfy.ai` nunca
 *    verificaram o e-mail, e entre elas está justamente quem PRODUZ os
 *    lookbooks. Exigir verificação esconderia a ferramenta de quem ela serve.
 *
 * 2. `isOrdersStaff` dá atalho para `role === 'admin'` de QUALQUER domínio. Para
 *    uma ferramenta descrita como "só nas contas @snapfy" isso é largo demais:
 *    basta promover um usuário externo a admin para a tag vazar.
 *
 * Sobre forjar um `@snapfy.ai`: o cadastro do domínio é bloqueado no backend
 * (`config/auth.php`), então não existe caminho de auto-registro. E este gate é
 * conveniência de UI — esconde uma etiqueta, não concede acesso a dado nenhum.
 */
export const isSnapfyInternal = (user: User | null | undefined): boolean => {
    const email = user?.email;
    if (!email) return false;

    const at = email.lastIndexOf('@');
    if (at < 0) return false;

    return email.slice(at + 1).toLowerCase() === 'snapfy.ai';
};
